function scrollPositionSessionStorageManager(key, existsKey) {
  const [, pathOfKey, keyTimestamp] = key.split('|')

  if (!keyTimestamp) {
    sessionStorage.removeItem(key)
  }

  if (existsKey) {
    const sessionStorageKeyByAcc = `@@scroll|${pathOfKey}|${existsKey.timestamp}`
    const isUpperTimestampOfCurrentKey = existsKey.timestamp < keyTimestamp
    const sessionStorageKeyForDelete = isUpperTimestampOfCurrentKey ? sessionStorageKeyByAcc : key

    sessionStorage.removeItem(sessionStorageKeyForDelete)
  }
}

function getScrollPositionBySessionStorage(location) {
  return Object.keys(sessionStorage).reduce((accValue, key) => {
    const [, pathOfKey, keyTimestamp] = key.split('|')
    const hasPageScrollPositionOnStorage = !!keyTimestamp && pathOfKey === location.pathname
    const existsKey = accValue[pathOfKey]

    scrollPositionSessionStorageManager(key, existsKey)

    if (hasPageScrollPositionOnStorage) {
      const isUpperTimestampOfCurrentKey = !!existsKey && existsKey.timestamp < keyTimestamp

      if (!existsKey || isUpperTimestampOfCurrentKey) {
        return {
          ...accValue,
          [pathOfKey]: {
            timestamp: keyTimestamp,
            value: sessionStorage.getItem(key),
          },
        }
      }
    }

    return accValue
  }, {})
}

function scrollToLastPositionOnPage(scrollPositionFromSessionStorage) {
  const scrollPosition = Object.values(scrollPositionFromSessionStorage)

  if (scrollPosition.length > 0) {
    const [{ value: offsetPosition }] = scrollPosition

    setTimeout(() => {
      window.scrollTo({
        top: offsetPosition,
        behavior: 'auto',
      })
    }, 100)
  }
}

export { getScrollPositionBySessionStorage, scrollToLastPositionOnPage }
